const languagesListNormalLabels = {
  language: [
    { id: 1, label: 'Afrikaans', value: 'af' },
    { id: 62, label: 'Amharic', value: 'am' },
    { id: 2, label: 'Arabic', value: 'ar' },
    { id: 3, label: 'Armenian', value: 'hy' },
    { id: 4, label: 'Azerbaijani', value: 'az' },
    { id: 5, label: 'Belarusian', value: 'be' },
    { id: 6, label: 'Bengali', value: 'bn' },
    { id: 7, label: 'Bosnian', value: 'bs' },
    { id: 8, label: 'Bulgarian', value: 'bg' },
    { id: 9, label: 'Cantonese', value: 'yue' },
    { id: 10, label: 'Catalan', value: 'ca' },
    { id: 11, label: 'Chinese', value: 'zh' },
    { id: 12, label: 'Croatian', value: 'hr' },
    { id: 13, label: 'Czech', value: 'cs' },
    { id: 14, label: 'Danish', value: 'da' },
    { id: 15, label: 'Dutch', value: 'nl' },
    { id: 16, label: 'English', value: 'en' },
    { id: 17, label: 'Estonian', value: 'et' },
    { id: 18, label: 'Finnish', value: 'fi' },
    { id: 19, label: 'French', value: 'fr' },
    { id: 20, label: 'Galician', value: 'gl' },
    { id: 21, label: 'German', value: 'de' },
    { id: 22, label: 'Greek', value: 'el' },
    { id: 63, label: 'Georgian', value: 'ka' },
    { id: 23, label: 'Hebrew', value: 'he' },
    { id: 24, label: 'Hindi', value: 'hi' },
    { id: 25, label: 'Hungarian', value: 'hu' },
    { id: 26, label: 'Icelandic', value: 'is' },
    { id: 27, label: 'Indonesian', value: 'id' },
    { id: 28, label: 'Italian', value: 'it' },
    { id: 29, label: 'Japanese', value: 'ja' },
    { id: 30, label: 'Kannada', value: 'kn' },
    { id: 31, label: 'Kazakh', value: 'kk' },
    { id: 32, label: 'Korean', value: 'ko' },
    { id: 33, label: 'Latvian', value: 'lv' },
    { id: 34, label: 'Lithuanian', value: 'lt' },
    { id: 35, label: 'Macedonian', value: 'mk' },
    { id: 36, label: 'Malay', value: 'ms' },
    { id: 37, label: 'Maori', value: 'mi' },
    { id: 38, label: 'Marathi', value: 'mr' },
    { id: 39, label: 'Nepali', value: 'ne' },
    { id: 40, label: 'Norwegian', value: 'no' },
    { id: 41, label: 'Punjabi', value: 'pa' },
    { id: 42, label: 'Persian', value: 'fa' },
    { id: 43, label: 'Polish', value: 'pl' },
    { id: 44, label: 'Portuguese', value: 'pt' },
    { id: 45, label: 'Romanian', value: 'ro' },
    { id: 46, label: 'Russian', value: 'ru' },
    { id: 47, label: 'Serbian', value: 'sr' },
    { id: 48, label: 'Slovak', value: 'sk' },
    { id: 49, label: 'Slovenian', value: 'sl' },
    { id: 50, label: 'Spanish', value: 'es' },
    { id: 51, label: 'Swahili', value: 'sw' },
    { id: 52, label: 'Swedish', value: 'sv' },
    { id: 53, label: 'Tagalog', value: 'tl' },
    { id: 54, label: 'Tamil', value: 'ta' },
    { id: 55, label: 'Thai', value: 'th' },
    { id: 56, label: 'Turkish', value: 'tr' },
    { id: 57, label: 'Ukrainian', value: 'uk' },
    { id: 58, label: 'Urdu', value: 'ur' },
    { id: 59, label: 'Uzbek', value: 'uz' },
    { id: 60, label: 'Vietnamese', value: 'vi' },
    { id: 61, label: 'Welsh', value: 'cy' },
  ],
};

export default languagesListNormalLabels;
